import React from "react";
import PathConstants from "./pathConstants";
import { RequireAppealId } from "../components/Shared/RequireAppealId";

// Report Appeal Result Flow
const AppealWonPage = React.lazy(
  () => import("../pages/Product/ReportingFlow/AppealWon"),
);
const ReviewAndSharePage = React.lazy(
  () => import("../pages/Product/ReportingFlow/ReviewAndShare"),
);
const DenialUpheldPage = React.lazy(
  () => import("../pages/Product/ReportingFlow/DenialUpheld"),
);
const DenialUpheldClaimFilePage = React.lazy(
  () => import("../pages/Product/ReportingFlow/DenialUpheldClaimFile"),
);
const AppealLostPage = React.lazy(
  () => import("../pages/Product/ReportingFlow/AppealLost"),
);

const routes = [
  {
    path: PathConstants.AppealWon,
    element: <AppealWonPage />,
  },
  {
    path: PathConstants.ReviewAndShare,
    element: <ReviewAndSharePage />,
  },
  {
    path: PathConstants.DenialUpheld,
    element: (
      <RequireAppealId>
        <DenialUpheldPage />
      </RequireAppealId>
    ),
  },
  {
    path: PathConstants.DenialUpheldClaimFile,
    element: (
      <RequireAppealId>
        <DenialUpheldClaimFilePage />
      </RequireAppealId>
    ),
  },
  {
    path: PathConstants.AppealLost,
    element: <AppealLostPage />,
  },
];

export default routes;
